import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import { useState, useRef, useEffect } from 'react';
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import BookUseListArea from "./area/book_use_list";

function TextbookStuUseListArea(props: any) {
  let myProps = {
    s_subject: "",
    ...props
  };
  const findStudentListRef = useRef<any>(null);
  const BookUseListAreaRef = useRef<any>(null);
  const right_box_ref = useRef<any>(null);

  const [stu_list_opt, set_stu_list_opt] = useState<any>({});

  useEffect(() => {
    if (findStudentListRef.current) {
      set_stu_list_opt(findStudentListRef.current.getListOpt());
    }
  }, []);

  return (
    <div>
      {stu_list_opt.s_user_name_like != undefined &&
        <SearchArea
          listOpt={stu_list_opt}
          setListOpt={(inData: any) => {
            if (findStudentListRef.current) {
              findStudentListRef.current.setListOpt(inData);
              set_stu_list_opt(inData);
            }
          }}
          list={(inData: any) => {
            if (findStudentListRef.current) {
              findStudentListRef.current.list(inData);
              set_stu_list_opt({
                ...stu_list_opt,
                ...inData
              });
            }
          }}
        ></SearchArea>
      }
      <div className="flex flex-row" style={{ gap: 15 }}>
        <div style={{ minWidth: 360 }} >
          <FindStudentList
            ref={findStudentListRef}
            list={(inData: any) => {
              //inData.s_stu_user_seq
              if (BookUseListAreaRef.current) {
                if (inData.s_stu_user_seq.length == 1) {
                  BookUseListAreaRef.current.setInitData({ stu_seq: inData.s_stu_user_seq[0] });
                }
              }
            }}
            grid_opt={{
              rowMultiSelectWithClick: false,
            }}
            listOpt={{
              s_addon_textbook_use: "1",
              s_addon_textbook_use_addon_book: "",
              s_addon_textbook_use_addon_order_det: "",
              s_addon_textbook_use_s_in_now_period: "1",
              s_addon_textbook_use_s_subject: myProps.s_subject,
              ...stu_list_opt
            }}
            is_show_search_area={false}
            show_key_arr={["row_view_textbook_use"]}
          ></FindStudentList>
        </div>
        <div style={{ flexGrow: 1, minWidth: 400 }}>
          <div ref={right_box_ref} style={{ paddingTop: "5px" }}>
            <BookUseListArea
              ref={BookUseListAreaRef}
              s_subject={myProps.s_subject}
              callBackRefreshData={(inData: any) => {
                if (findStudentListRef.current) {
                  findStudentListRef.current.list(inData);
                }
              }}
            ></BookUseListArea>
          </div>
        </div>
        <RightScrollFix right_ref={right_box_ref} limit_scroll_top={300}></RightScrollFix>
      </div>
    </div>
  );
};
export default TextbookStuUseListArea;